import { Button } from '@progress/kendo-react-buttons';
import { useResize } from 'common/hooks/resize';
import './errorpage.scss';

function ContactSupportButton({
  className,
  buttonColor = 'primary',
}: Readonly<{
  className?: string;
  buttonColor?: any;
}>) {
  const { isMobile } = useResize();

  const onClick = () => {
    if (isMobile) {
      window.location.href = 'mailto:support@accelerationpoint.com?subject=Kwello Support Request';
    } else {
      const { Intercom } = window;
      if (Intercom) {
        Intercom('showSpace', 'messages');
      } else {
        window.location.href =
          'mailto:support@accelerationpoint.com?subject=Kwello Support Request';
      }
    }
  };

  return (
    <Button className={className} themeColor={buttonColor} onClick={onClick} size="large">
      Contact Support
    </Button>
  );
}

export default ContactSupportButton;
